<template>
  <div class="page" id="mixed-notes">
    <vue-snotify></vue-snotify>
    <side-menu :menuOn="menuOn" @menuVisible="menuVisible"></side-menu>
    <mnavbar @menuVisible="menuVisible"></mnavbar>
    <export-file :nombre="csvName" :isActive="isActive" @closeModal="() => { this.isActive = false }"
      @exportCSV="exportCSV"></export-file>
    <div class="toolBar">
      <!-- desktop -->
      <div class="row" v-if="gtSm">
        <div class="col">
          <h2 class="toolBarTitle">Canales</h2>
        </div>
        <div class="col-auto">
          <div :class="['button buttonTool', { 'selectedKeyword': actFavoritos }, 'tooltip']" data-tooltip="Activar Favoritos" @click="getChanelsFavoritos" style="max-height:35px;">
            <svg aria-hidden="true" width="20" height="20" fill="currentColor" focusable="false" data-prefix="fas"
              data-icon="calendar-day" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
              <path
              d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z" />
            </svg>
          </div>
        </div>
        <div class="col text-center">
          <h1 class="barTitle text-center">{{ this.medios[medio] ? this.medios[medio].nombre : '' }}</h1>
        </div>
        <div class="col-auto">
          <div class="button buttonTool tooltip" data-tooltip="Buscar" @click="search" style="max-height:35px;" v-if="this.medios[medio].fi != 'T' && this.medios[medio].fi != 'R'">
            <svg aria-hidden="true" width="20" height="20" fill="currentColor" focusable="false" data-prefix="fas"
              data-icon="calendar-day" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
          </div>
        </div>
        <div class="col toolActions " style="text-align:right!important;">
          <div class="toolBarfecha">{{ parseFecha(fecha) }}</div>
          <div class="button buttonTool tooltip" data-tooltip="Actualizar" @click="reload" style="max-height:35px;">
            <font-awesome-icon icon="sync" />
          </div>
          <v-date-picker data-tooltip="Cambiar fecha" style="max-height:35px"
            class="button buttonTool calendar tooltip superIndex" color="gray"
            :popover="{ placement: 'bottom', visibility: 'click', positionFixed: true }" :max-date="new Date()"
            :min-date="getMinDate()" v-model="fechaTmp">
            <svg aria-hidden="true" width="20" height="20" fill="currentColor" focusable="false" data-prefix="fas"
              data-icon="calendar-day" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z" />
            </svg>
          </v-date-picker>
          <!--<div class="separator"></div>-->

        </div>
        <div class="col">
          <div class="mi-select-egm">
            <v-select :value="options[view - 1]" :reduce="option => option.value" :searchable="false" :filterable="false"
              :clearable="false" class="style-chooser" :options="options" @input="setSelected">
            </v-select>
          </div>
        </div>
        <div class="col">
          <div class="mi-select-egm">
            <span class="selectTitle" v-if="tGp != 'Grupos'">Grupos</span>
            <v-select :value="tGp" :reduce="option => option.value" :searchable="false" :filterable="false"
              :clearable="false" class="style-chooser" :options="options2" @input="setSelectedGrupo">
            </v-select>
           
          </div>
        </div>
        <div class="col">
          <div class="mi-select-egm">
            <span class="selectTitle" v-if="tEn != 'Entidades'">Entidades</span>
            <v-select :value="tEn" :reduce="option => option.value" :searchable="false" :filterable="false"
              :clearable="false" class="style-chooser" :options="options3" @input="setSelectedRegion" v-if="medio == 0 || medio == 1">
            </v-select>
            <v-select :value="tEn" :reduce="option => option.value" :searchable="false" :filterable="false"
              :clearable="false" class="style-chooser" :options="optionsCiudad" @input="setSelectedRegion" v-else>
            </v-select>
          </div>
        </div>
        <div class="col-auto">

          <div class="keywords">
            <div :class="['button buttonTool', { 'selectedKeyword': medio == index }, 'tooltip']" :data-tooltip="m.nombre"
              v-for="(m, index) in medios" :key="index" @click="changeMedio(index)">
              <svg v-if="m.fi == 'FB'" width="20px" height="20px" viewBox="0 0 24 24">
                <path
                  d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />
              </svg>


              <svg v-if="m.fi == 'TW'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" />
              </svg>
              <svg v-if="m.fi == 'T'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1" width="20px" height="20px" viewBox="0 0 24 24">
                <path
                  d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
              </svg>
              <svg v-if="m.fi == 'R'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24">
                <path
                  d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" />
              </svg>
              <svg v-if="m.fi == 'Y'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24">
                <path
                  d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" />
              </svg>
              <svg v-if="m.fi == 'I'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24">
                <path
                  d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z" />
              </svg>
              <svg v-if="m.fi == 'PD'" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512">
                <path
                  d="M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z" />
              </svg>

              <svg v-if="m.fi == 'TK'" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 32 32">
                <path
                  d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
              </svg>

            </div>
          </div>
        </div>
        <!--BOTONES-->
      </div>
      <!-- mobile -->
      <div class="row" v-else>
        <div class="col-12">
          <h2 class="toolBarTitle">Canales</h2>
        </div>
        <div class="col-12">
          <div class="keywords">
            <div :class="['button buttonTool', { 'selectedKeyword': medio == index }, 'tooltip']" :data-tooltip="m.nombre"
              v-for="(m, index) in medios" :key="index" @click="changeMedio(index)">
              <svg v-if="m.fi == 'FB'" width="20px" height="20px" viewBox="0 0 24 24">
                <path
                  d="M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z" />
              </svg>
              <svg v-if="m.fi == 'TW'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 4500 4500">
                <path d="M0 4579 c-2 -3 160 -224 359 -490 199 -266 622 -832 940 -1257 l578
        -773 -37 -42 c-21 -23 -446 -482 -944 -1020 -498 -539 -907 -983 -908 -988 -2
        -5 85 -9 210 -8 l213 1 70 77 c39 42 401 433 805 870 404 437 746 807 760 823
        l25 29 200 -268 c110 -147 413 -553 673 -901 l474 -632 725 0 c603 0 724 2
        720 13 -3 8 -187 256 -409 553 -222 296 -476 636 -564 754 -89 118 -350 469
        -582 778 -232 310 -422 568 -422 572 0 7 1226 1338 1643 1783 l119 127 -219 0
        -218 -1 -255 -276 c-140 -152 -483 -524 -763 -825 l-507 -548 -615 822 -616
        823 -725 5 c-399 3 -728 2 -730 -1z m1718 -886 c237 -318 603 -807 813 -1088
        210 -280 676 -904 1036 -1385 360 -482 658 -881 663 -888 6 -9 -65 -12 -324
        -12 l-331 0 -656 878 c-1514 2023 -2278 3045 -2287 3060 -6 9 62 12 323 12
        l331 0 432 -577z" />
              </svg>
              <svg v-if="m.fi == 'T'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                version="1.1" width="20px" height="20px" viewBox="0 0 24 24">
                <path
                  d="M8.16,3L6.75,4.41L9.34,7H4C2.89,7 2,7.89 2,9V19C2,20.11 2.89,21 4,21H20C21.11,21 22,20.11 22,19V9C22,7.89 21.11,7 20,7H14.66L17.25,4.41L15.84,3L12,6.84L8.16,3M4,9H17V19H4V9M19.5,9A1,1 0 0,1 20.5,10A1,1 0 0,1 19.5,11A1,1 0 0,1 18.5,10A1,1 0 0,1 19.5,9M19.5,12A1,1 0 0,1 20.5,13A1,1 0 0,1 19.5,14A1,1 0 0,1 18.5,13A1,1 0 0,1 19.5,12Z" />
              </svg>
              <svg v-if="m.fi == 'R'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24">
                <path
                  d="M12 10a2 2 0 0 1 2 2a2 2 0 0 1-.47 1.29L16.7 22h-2.13L12 14.93L9.43 22H7.3l3.17-8.71A2 2 0 0 1 10 12a2 2 0 0 1 2-2m0-2a4 4 0 0 0-4 4c0 .5.1 1 .28 1.46l-.88 2.4A6.026 6.026 0 0 1 6 12a6 6 0 0 1 6-6a6 6 0 0 1 6 6c0 1.47-.53 2.81-1.4 3.86l-.88-2.4C15.9 13 16 12.5 16 12a4 4 0 0 0-4-4m0-4a8 8 0 0 0-8 8c0 2.36 1 4.5 2.64 5.94l-.72 2A10.005 10.005 0 0 1 2 12A10 10 0 0 1 12 2a10 10 0 0 1 10 10c0 3.23-1.54 6.11-3.92 7.94l-.72-2C19 16.5 20 14.36 20 12a8 8 0 0 0-8-8z" />
              </svg>
              <svg v-if="m.fi == 'Y'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24">
                <path
                  d="M10 15l5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73z" />
              </svg>
              <svg v-if="m.fi == 'I'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                aria-hidden="true" focusable="false" width="20px" height="20px" preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24">
                <path
                  d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3z" />
              </svg>
              <svg v-if="m.fi == 'PD'" width="20px" height="20px" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512">
                <path
                  d="M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z" />
              </svg>
              <svg v-if="m.fi == 'TK'" xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 32 32">
                <path
                  d="M16.708 0.027c1.745-0.027 3.48-0.011 5.213-0.027 0.105 2.041 0.839 4.12 2.333 5.563 1.491 1.479 3.6 2.156 5.652 2.385v5.369c-1.923-0.063-3.855-0.463-5.6-1.291-0.76-0.344-1.468-0.787-2.161-1.24-0.009 3.896 0.016 7.787-0.025 11.667-0.104 1.864-0.719 3.719-1.803 5.255-1.744 2.557-4.771 4.224-7.88 4.276-1.907 0.109-3.812-0.411-5.437-1.369-2.693-1.588-4.588-4.495-4.864-7.615-0.032-0.667-0.043-1.333-0.016-1.984 0.24-2.537 1.495-4.964 3.443-6.615 2.208-1.923 5.301-2.839 8.197-2.297 0.027 1.975-0.052 3.948-0.052 5.923-1.323-0.428-2.869-0.308-4.025 0.495-0.844 0.547-1.485 1.385-1.819 2.333-0.276 0.676-0.197 1.427-0.181 2.145 0.317 2.188 2.421 4.027 4.667 3.828 1.489-0.016 2.916-0.88 3.692-2.145 0.251-0.443 0.532-0.896 0.547-1.417 0.131-2.385 0.079-4.76 0.095-7.145 0.011-5.375-0.016-10.735 0.025-16.093z" />
              </svg>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="mi-select">
            <v-select :value="options[view - 1]" :reduce="option => option.value" :searchable="false" :filterable="false"
              :clearable="false" class="style-chooser" :options="options" @input="setSelected">
            </v-select>
          </div>
        </div>
        <div class="col-6" style="right:0">
          <v-date-picker data-tooltip="Cambiar fecha" style="max-height:35px;" color="gray"
            :popover="{ placement: 'bottom', visibility: 'click' }" :max-date="new Date()" v-model="fechaTmp">
            <button class="button buttonTool calendar tooltip">
              <svg aria-hidden="true" width="20" height="20" fill="currentColor" focusable="false" data-prefix="fas"
                data-icon="calendar-day" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                <path
                  d="M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z" />
              </svg>
            </button>
          </v-date-picker>
          <div class="button buttonTool tooltip" data-tooltip="Refrescar" @click="reload" style="max-height:35px">
            <font-awesome-icon icon="sync" />
          </div>
        </div>
      </div>
    </div>
    <section :class="['noPadding']">
      <div class="container_news">

        <div class="row">
          <div class="col-sm-12">
            <div class="row" v-if="medios[medio]">
              <canales v-if="ready && recargarCanales == false" :fi="medios[medio].fi" :titulo="medios[medio].nombre" :key="medio"
                :currents="currents" @addChannel="addChannel" @error="error" @reload="reload" :fecha="fecha" :idGrupo="selectGrupo" :idRegion="selectRegion" :actFav="actFavoritos"></canales>
            </div>
            <div :class="['row']" v-if="view == 2">
              <escaleta v-for="(i, ndx) in items" :ndx="ndx" :key="i.key" :params="getParams(i, ndx)" :fquery="fEscaleta"
                :fLetrero="fLetrero" @back="back" @goToNoteTimeline="goToNote" @download="download" @borrar="borrar">
              </escaleta>
            </div>
            <div class="row" v-if="view == 1 && medio >= 0">
              <noti-notas :medio="medios[medio].fi" :ndx="ndx" :item="i" @goToNote="goToNote" @goToNotes="goToNotes"
                v-for="(i, ndx) in items" :key="i.key" @borrar="borrar" @escaleta="escaleta" :fecha="fecha"
                @download="download"></noti-notas>
            </div>
            <div :class="['row']" v-if="view == 3">
              <viewfull v-for="(i, ndx) in items" :ndx="ndx" :key="i.key" :params="getParams(i, ndx)" :fquery="fEscaleta"
                :fLetrero="fLetrero" @back="back" @download="download" @borrar="borrar">
              </viewfull>
            </div>
            <div class="button-circle-more secondary " v-if="LastEvaluatedKey && esc == false">
              <button class="button circle-more tooltip" data-tooltip="cargar más canales" @click="loadMore">
                <svg viewBox="0 0 18 18">
                  <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
                    <rect id="Rectángulo_redondeado_903" data-name="Rectángulo redondeado 903" width="2" height="18"
                      rx="1" transform="translate(179 753)" fill="#fff" />
                    <rect id="Rectángulo_redondeado_903_copia" data-name="Rectángulo redondeado 903 copia" width="18"
                      height="2" rx="1" transform="translate(171 761)" fill="#fff" />
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <!-- END BUTTON CIRCLE -->
      </div>

    </section>
  <search-box :show="searchAlt" :medio="medioAlt" @cancelar="cancelarSearch" @reloadSearch="reload" ></search-box> <!--@share="share"-->
  </div>
</template>
<script>
import SideMenu from "@/components/sideMenu";

import mnavbar from "@/components/mnavbar";

import notiNotas from "@/components/notiNotas";
import canales from "@/components/canales";

import moment from "moment-timezone";
import searchBox from "@/components/searchBox";
import escaleta from "@/components/escaleta";
import viewfull from "@/components/viewfull"
import exportFile from "@/components/exportFile";


import { library } from "@fortawesome/fontawesome-svg-core";
import { faListAlt, faSync } from "@fortawesome/free-solid-svg-icons";

import Snotify, { SnotifyPosition } from 'vue-snotify'
import 'vue-snotify/styles/simple.css';
import VueNativeSock from 'vue-native-websocket'
library.add(faListAlt);
library.add(faSync);


export default {
  props: ["m", "f"],
  components: { mnavbar, SideMenu, notiNotas, canales, escaleta, exportFile,viewfull,searchBox },
  data() {
    return {
      isLoading: false,
      activos: true,
      menuOn: false,
      url: this.$store.getters.getMainUrl,
      providerID: this.$store.state.userInfo.net,
      items: [],
      item: {},
      total: 0,
      LastEvaluatedKey: null,
      LastEvaluatedKeyBack: null,
      lastPage: false,
      dirFrom: null,
      dir: null, //manejador paginas listado
      itemsPerPage: 10,
      medio: 0,
      medios: [],
      mediosDefault: [
        { fi: "T", nombre: "Televisión" },
        {
          fi: "R",
          nombre: "Radio"
        },
        {
          fi: 'PD',
          nombre: 'Periódico Digital',
          feed: "rss"
        },
        {
          fi: "Y",
          nombre: "Youtube",
          feed: "youtube"
        },
        {
          fi: "FB",
          nombre: "Facebook",
          feed: "facebook"
        },
        {
          fi: "TW",
          nombre: "Twitter",
          feed: "twitter"
        },
        {
          fi: "TK",
          nombre: "Tiktok",
          feed: "Tiktok"
        },
        /* {
           fi: "I",
           nombre: "Instagram",
           feed: "instagram"
         }*/
      ],
      limit: 6,
      esc: false,
      params: {},
      fecha: "",
      fEscaleta: "",
      fLetrero: "",
      fechaTmp: this.$store.state.fecha,
      //view:false, //escaleta
      currents: [],
      modeLetrero: "Cambiar a modo escaleta",
      isActive: false, // exportar archivo CSV
      queryCSV: {},
      ready: true,
      intevarlo: null,
      csvName: '', //nombre csv pro default el de la escaleta
      options: [{ label: 'Carrousel', value: 1 }, { label: 'Escaleta', value: 2 }, { label: 'Completa', value: 3 }/*{label:'Modo Texto',value:2}*/],
      options2: [{ label: 'Todos', value: 0 }],
      options3: [{ label: 'Todos', value: 0 }],
      view: 2,//default: carrousel
      gtSm: false,
      selectGrupo:0,
      selectRegion:0,
      recargarCanales: false,
      tGp: "Grupos",//EGM
      tEn: "Entidades",
      seccion: [],
      notificationGroups: {},
      notifications:[],
      actFavoritos: false,
      optionsCiudad:[],
      searchAlt: false,
      medioAlt: '',
    };
  },
  created() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy() {
    clearInterval(this.intevarlo);
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  computed: {
    token() {
      return this.$store.getters.getToken;
    },
    mode() {
      return this.$store.getters.getChannelsMode;
    }
  },
  async beforeMount() {
    this.$store.commit("resetBackData");

    //CARGAMOS LOS MEDIOS QUE TIENE ACCESO EL USUARIO
    var r = await this.getPermisosFeeds();
    if (r.success) {
      var mis_medios = r.data;
      console.log(r.data);
      var mis_medios = this.ordenarLista(r.data);

      for (var i in mis_medios) {
        for (var j in this.mediosDefault) {
          var medio = this.mediosDefault[j];
          if (medio.fi == mis_medios[i]) {
            this.medios.push(medio);
          }
        }
      }
      if (this.medios.length == 0) {//vacios
        this.medios = this.mediosDefault;
      }
    } else {
      this.error(r.error);
    }


    this.medio = this.$store.state.channel;
    console.log('medio guardado', this.medio);

    if (this.medios[this.medio] == undefined) {
      this.medio = 0
    }

    this.fecha = this.getFecha();
    this.init();
    //this.intevarlo = setInterval(this.subreload, 600000); //cada 10 min
    this.getMediaGroups() //EGM280823
    this.getMediaRegiones() //EGM090324
    this. getMediaCiudad() 
  },
  watch: {
    fechaTmp() {
      this.changeDate(this.fechaTmp);
    }
  },
  
  sockets: {
    onopen() {
      setTimeout(() => {
      this.wssCerrarNotificacion();
     
      },1500);
      setTimeout(() => {
     
      this.wssRegisterNotificion();
     
      },2000);
      
    },
    onmessage(data) {
      this.nuevaNotificacion2(data.data)
    
    },
    onclose() {
      
    },
    onerror(error) {

    }
  },
  methods: {
    nuevaNotificacion2(data) {
      var self = this;
      let parsedData = JSON.parse(data);
      this.addNotification2(parsedData);
    },
    addNotification2(parsedData) {
      let key;
      let nom;
      switch (parsedData.entrada) {
        case "T":
        case "R":
          key = `radio-${parsedData.noticiero.nombre}`;
          nom = parsedData.noticiero.nombre;
          break;
        case "PD":
          key = `periodico-${parsedData.noticiero_nombre}`;
          nom = parsedData.noticiero_nombre;
          break;
        case "FB":
        case "TW":
        case "Y":
        case "I":
          key = `social-${parsedData.autor}`;
          nom = parsedData.autor;
          break;
        case "TK":
          key = `tk-${parsedData.title}`;
          nom = parsedData.title;
          break;
        default:
          key = `other-${parsedData.entrada}`;
          nom = parsedData.entrada;
          break;
      }
      
      if (!this.notifications[key]) {
        this.notifications[key] = { count: 0, message: '' };
      }
      this.notifications[key].count++;
      this.notifications[key].message = parsedData.titulo;
      this. notifications[key].titulo = nom;// Puedes personalizar el mensaje aquí
      
      // Mostrar notificaciones resumidas después de un tiempo
      setTimeout(() => {
        this.showGroupedNotifications();
      }, 4000); // Ajusta el tiempo según sea necesario
   },
   showGroupedNotifications() {
    let coutNo = Object.keys(this.notifications).length;
    if(coutNo < 2 ){
      for (let key in this.notifications) {
        const notification = this.notifications[key];
       
        if (notification.count == 1){
            this.$snotify.info(`${notification.titulo}: ${notification.message}`, 'Nueva nota', {
            timeout: 2000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            position: SnotifyPosition.rightTop
          });
        }
        if (notification.count >=2){
            this.$snotify.info(`${notification.count} nuevas notas de ${notification.titulo}`, 'Nuevas notas', {
            timeout: 2000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            position: SnotifyPosition.rightTop
          });
        }
      }
    }else{
      let canalesTitulos = "";
      for (let key in this.notifications) {
        const notification = this.notifications[key];
        if (canalesTitulos !== "") {
          canalesTitulos += ", ";
        }
        canalesTitulos += notification.titulo;
       
      }
      this.$snotify.info(canalesTitulos, 'Nuevas notas de: ', {
            timeout: 2000,
            showProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            position: SnotifyPosition.rightTop
          });
    }
    this.notifications = {}; // Limpiar después de mostrar
  },
    ordenarLista(listas) {
      var lista = listas;
      var index = lista.indexOf("TK");
      console.log(index, "index");
      if (index > 0) {
        console.log("entra al ordenar");
        var item = lista[index];
        lista.splice(index, 1);
        lista.push(item);
      }
      console.log(lista, "lista=====<");
      return lista;
    },
    init() {
      console.log('init');
      this.wssCerrarNotificacion();
      var medio = this.medios[this.medio];
      console.log('medio', medio);
      switch (medio.fi) {
        case "T":
        case "R":
        case "PD":
          this.getCanales();
          break;
          break;
        case "FB":
        case "TW":
        case "Y":
        case "I":
        case "TK":
          this.getFeeds();
          break;
      }
    },
    wssRegisterNotificion(){
      var self = this;
      var mensajeUser = {
        message : 'registerUser',
          seccion : self.seccion,
          token : this.token,
      }
      self.$socket.send(JSON.stringify(mensajeUser));
    },
    wssCerrarNotificacion(){
      var self = this;
      var mensajeUser = {
          message : 'deleteRegister',
          token : this.token,
      }
        self.$socket.send(JSON.stringify(mensajeUser));
    },
    wssFavoritosCaneles(datos){
      
      var self = this;
      const seccion = datos.map(obj => obj.medio +'_' + obj.key);
      self.seccion = seccion;
      self.wssRegisterNotificion();
    },
    wssFavoritosFeeds(datos){
      console.log(datos)
      const nuevoArray = datos.map(obj => obj.medio +'_' + obj.key);
      console.log(nuevoArray)
    },
    getCanales() {
      //sliders de canales
      var medio = this.medios[this.medio].fi;
      var post_data = {
        token: this.token,
        medio: medio,
        limit: 5
      };
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      var self = this;
      //var arrFavs = [];
      axios
       .post(self.url + "getNewsDashboardTest", JSON.stringify(post_data))
         .then(response => {
          self.ready = true;
          if (self.items.length == 0) {
            self.items = response.data.result;
          } else {
            self.items = [].concat(self.items, response.data.result);
          }
          self.wssFavoritosCaneles(response.data.result);
          self.LastEvaluatedKey = response.data.LastEvaluatedKey
            ? response.data.LastEvaluatedKey
            : null;
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    getFeeds() {
      var feed = this.medios[this.medio].feed;
      var medio = this.medios[this.medio].fi;
      var post_data = {
        providerID: this.providerID,
        token: this.token,
        feed: feed,
        limit: 20,
        medio: medio
      };
      if (this.LastEvaluatedKey)
        post_data["LastEvaluatedKey"] = this.LastEvaluatedKey;
      var self = this;
      axios
      .post(self.url + "getNewsDashboardTest", JSON.stringify(post_data))
        .then(response => {
          if (self.items.length == 0) {
            self.items = response.data.result;
          } else {
            self.items = [].concat(self.items, response.data.result);
          }
          self.wssFavoritosCaneles(response.data.result)
          self.LastEvaluatedKey = response.data.LastEvaluatedKey
            ? response.data.LastEvaluatedKey
            : null;
          self.ready = true;
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    goToNote(item) {
      console.log(item, "item");
      var name = "";
      var fi = item.fi ? item.fi : item.entrada;
      switch (fi) {
        case "T":
        case "R":
          name = "notaVideo";
          break;
        case "Y":
          name = "notaYoutube";
          break;
        case "FB":
        case "I":
        case "TW":
          name = "notaEmbedded";
          break;
        case "PD":
          name = "notaText";
          break;
        case "TK":
          name = "notaTk";
          break;
      }

      var fromParams = {
        fi: fi,
        id: item.id ? item.id : item.key
      };
      if (item.entrada == "TK") {
        fromParams = {
          fi: fi,
          id: item.key
        };
      }

      var params = { from: "channels" };
      this.$store.commit("saveBack2", params);

      this.$router.push({ name: name, params: fromParams });
    },
    goToNotes(miconfig) {
      console.log("aqui es we");
      var query = {
        fi: {},
        keywords: [],
        ubicacion: "global",
        dias: 30,
        fecha: {}
      };

      var arr = [];
      arr.push(miconfig.key_src);
      query.fi[miconfig.entrada] = arr;
      query.fiParams = {};


      var p = { from: 'channels' };
      this.$store.commit('saveBack2', p);

      this.$router.push({ name: 'notas', params: { query: query } });
    },
    reload() {
      this.ready = false;
      this.clean();
      this.init();
    },
    subreload() {
      this.clean();
      this.init();
    },
    changeMedio(ndx) {

      this.medio = ndx;
      this.esc = false;
      this.currents = [];
      this.$store.commit('saveChannel', this.medio);
      this.reload();
      if(this.medio == 0 || this.medio == 1){ //EGM290823
        this.getMediaGroups()
        //this.getMediaRegiones() //EGM090324
      }
    },
    loadMore() {
      if (this.LastEvaluatedKey) {
        this.init();
      } else {
        this.$snotify.clear();
        this.$snotify.info("Ya no ha más notas", "Info");
      }
    },
    addChannel(obj) {
      console.log('addChannel', obj);
      const seccion =  this.medios[this.medio].fi +'_' + obj.key;
      this.seccion.push(seccion)
      setTimeout(() => {
        this.wssCerrarNotificacion();
      },"1500");
      setTimeout(() => {
        this.wssRegisterNotificion();
      },"2000");
      this.items.unshift(obj);
      this.currents.push(obj.key);
    },
    borrar(ndx) {
      var item = this.items[ndx];
      console.log(this.currents);
      console.log(item.key);
      var fi = this.medios[this.medio].fi;
      this.removeFav(item.key, ndx);
      /*switch (fi) {
        case "T":
        case "R":
        case "PD":
          this.removeFav(item.key, ndx);
        break;
        default:
          if (item.fav) this.removeFavFeed(item.key, ndx);
          else
            this.error('Elimine este Feed desde configuración');
          break;
      }*/
      var pos = this.currents.indexOf(item.key);
      if (pos >= 0) this.currents.splice(pos, 1);
      const elementoSeccion =  this.medios[this.medio].fi +'_' + item.key;
      this.seccion = this.seccion.filter(sec => sec !== elementoSeccion);
      setTimeout(() => {
        this.wssCerrarNotificacion();
      },"1500");
      setTimeout(() => {
        this.wssRegisterNotificion();
      },"2000");
    },
    removeFav(key, ndx) {
      var post_data = {
        token: this.token,
        key: key,
        medio: this.medios[this.medio].fi
      };
      var self = this;
      axios
        //.post(this.url + "deleteNoticierosFromUser", JSON.stringify(post_data)) 
        .post(this.url + "delNewsDashboard", JSON.stringify(post_data)) //EGM 241112
        .then(response => {
          if (response.data.success) {
            self.items.splice(ndx, 1);
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    removeFavFeed(key, ndx) {
      var post_data = {
        token: this.token,
        key: key,
        feed: this.medios[this.medio].feed
      };
      var self = this;
      axios
        .post(this.url + "removeFavFeed", JSON.stringify(post_data))
        .then(response => {
          if (response.data.success) {
            self.items.splice(ndx, 1);
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    deleteUserFeed(key, ndx) {
      var post_data = {
        providerID: this.providerID,
        token: this.token,
        key: key,
        feed: this.medios[this.medio].feed
      };
      var self = this;
      axios
        .post(this.url + "deleteUserFeed", JSON.stringify(post_data))
        .then(response => {
          if (response.data.success) {
            self.items.splice(ndx, 1);
          }
        })
        .catch(function (error) {
          self.error(error);
        });
    },
    error(msg) {
      this.$snotify.clear();
      this.$snotify.error(msg, this.$store.state.error);
    },
    success(msg) {
      this.$snotify.clear();
      this.$snotify.success(msg, this.$store.state.success);
    },
    clean() {
      this.fechaTmp = new Date();
      this.items = [];
      this.total = 0;
      this.LastEvaluatedKey = null;
    },
    menuVisible(menu) {
      this.menuOn = menu;
    },
    /// -------- Escaleta ------
    getParams(item, ndx) {

      var fi = this.medios[this.medio].fi;
      var params = {
        fi: fi,
        item: item,
        items: [],
        mode: 2,
        LastEvaluatedKey: 0,
        from: 'channels',
        entrada: this.medios[this.medio].fi
      }
      return params;
    },
    escaleta(obj) {
      console.log('escaleta');
      console.log(obj)
      var ndx = obj.ndx;
      var item = this.items[ndx];
      var fi = this.medios[this.medio].fi;
      var nota = obj.item;
      var fechaMX = this.getFechaMx(nota.fecha);
      var arr_fecha = fechaMX.f1.split(' ');
      var f = arr_fecha[0];
      var arr_fecha2 = fechaMX.f2.split(' ');
      var f2 = arr_fecha2[0];
      console.log('fecha escaleta:', f);
      this.params = {
        fi: fi,
        item: item,
        items: obj.items,
        LastEvaluatedKey: obj.LastEvaluatedKey,
        from: 'channels',
        entrada: this.medios[this.medio].fi
      }
      this.fEscaleta = f;
      this.fLetrero = f2;

      this.esc = true;
      this.currents.push(item.key);
    },
    getFecha() {
      var newFecha = this.$store.state.fecha;

      var anio = newFecha.getFullYear();
      var mes = newFecha.getMonth() + 1;
      var dia = newFecha.getDate();
      dia = dia <= 9 ? '0' + dia : dia;
      mes = mes <= 9 ? '0' + mes : mes;
      var miFecha = anio + '-' + mes + '-' + dia;

      return miFecha;
    },
    getFechaMx(fecha) {
      var tmp = moment(fecha);
      var f = moment.tz(tmp, 'America/Mexico_City');
      var r = {
        f1: f.format('YYYY-MM-DD HH:mm:ss'),
        f2: f.format('DD-MM-YYYY HH:mm:ss'),
      }
      return r;
    },
    back() {
      this.esc = false;
    },
    clear() {
      this.items = [];
      this.total = 0;
      this.LastEvaluatedKey = null;
    },
    changeDate(fecha) {
      var newFecha = fecha;
      var anio = newFecha.getFullYear();
      var mes = newFecha.getMonth() + 1;
      var dia = newFecha.getDate();
      dia = dia <= 9 ? '0' + dia : dia;
      mes = mes <= 9 ? '0' + mes : mes;
      var miFecha = anio + '-' + mes + '-' + dia;
      var fechaJs = new Date(anio, mes - 1, dia);
      console.log('fechaJs: ', fechaJs);
      //this.$store.commit('saveDate',fechaJs);
      this.fecha = miFecha;


      this.fEscaleta = miFecha;
      //this.fLetrero = dia+'/'+mes+'/'+anio;

      //this.reload();
    },
    parseFecha(fecha) {//2020-02-15
      var f_arr = fecha.split('-');
      var new_f = f_arr.length == 3 ? f_arr[2] + '/' + f_arr[1] + '/' + f_arr[0] : '';
      return new_f;
    },
    //EXPORT FILE CSV
    download(query) {
      this.queryCSV = query;
      console.log(query);
      this.csvName = query.titulo;
      this.isActive = true;
    },
    exportCSV(fName) {

      const fechaMX = this.getFechaMx(this.fechaTmp);

      if (fName.fName.trim() == "") {
        this.error("Ingrese un Nombre");
        return 0;
      }
      this.isActive = false;
      this.queryCSV.fecha = {
        "ini": fechaMX.f1.split(' ')[0],
        "fin": fechaMX.f1.split(' ')[0]
      };
      this.queryCSV.dias = "";
      var that = this;
      var dat = JSON.stringify({
        token: that.token,
        query: that.queryCSV,
        nombre: fName.fName,
        resumen : fName.fRes
      });
      axios
        .post(that.url + "downloadCSV", dat)
        .then(function (response) {
          if (response.data.success == true) {
            that.success(
              "Se generó un nuevo archivo, en breve se encontrará en la sección de descargas"
            );
          } else {
            that.error('Surgió un error, intente nuevamente');
          }
        })
        .catch(function (error) {
          console.log("Error");
          console.log(error);
        });
    },
    setSelected(value) {//cambiar vista: escaleta, modo gráfico, texto
      this.view = value;
    },
    setSelectedGrupoLocal(){
      this.selectGrupo = value;
      this.tGp = value == 0 ? "Grupos" : value;


    },
    setSelectedGrupo(value) {//cambiar vista: escaleta, modo gráfico, texto
      console.log(value);
      this.selectGrupo = value;
      this.tGp = value == 0 ? "Grupos" : value;
      //this.getMediaRegiones(value);
      this.recargarCanales = true;
      setTimeout(() => {
        this.recargarCanales = false;
      },"1500");
    },
    setSelectedRegion(value) {//cambiar vista: escaleta, modo gráfico, texto
      //this.options2 = [{ label: 'Todos', value: 0 }]      
      //this.getMediaGroups(value);
      this.tEn = value == 0 ? "Entidades" : value;
      this.selectRegion =  value;
      this.recargarCanales = true;
      setTimeout(() => {
        this.recargarCanales = false;
      },"1500");
    },
    getChanelsFavoritos() {//cambiar vista: escaleta, modo gráfico, texto
      this.actFavoritos = !this.actFavoritos
      this.recargarCanales = true;
      setTimeout(() => {
        this.recargarCanales = false;
      },"1500");
    },
    async getPermisosFeeds() {
      var self = this;
      return new Promise(resolve => {
        axios.post(this.url + 'getPermisosFeeds', JSON.stringify({ token: self.token })) //petición
          .then((response) => {
            self.isLoading = false;
            resolve(response.data);
          })
          .catch(function (error) {
            self.isLoading = false;
            var response = { success: false, error: error }
            console.log(error);
            resolve(response);
          });
      });
    },
    onResize() {
      this.gtSm = window.innerWidth > 480
    },
    getMinDate() { //60 dias atrás
      var minimo = moment().subtract(60, 'd');
      var fecha = new Date(minimo.format('YYYY-MM-DD HH:mm:ss'));
      return fecha;
    },
    getMediaGroups(v) { ///EGM290823
      //sliders de canales
      console.log(v)
      var self = this;
      //var arrFavs = [];
      axios
        .post(self.url + "getMediaGroups", JSON.stringify({ token: self.token, medio: this.medio, gpo: v }))
        .then(response => {
          console.log("-------------------HERRE");
          console.log(response.data);
          //self.ready = true;
          if (response.data.success) {
            self.options2 = self.options2.concat(response.data.data) //EGM290823
            //self.items = response.data.result;
          } else {
            //self.items = [].concat(self.items, response.data.result);
          }

        })
        .catch(function (error) {
          self.error(error);
        });
    },
    getMediaCiudad() { ///EGM290823
      //sliders de canales
      this.options3 = [];
      var self = this;
      //var arrFavs = [];
      axios
        .post(this.url + "getMediaCiudadRegion", JSON.stringify({ token: self.token, medio: this.medio, grupo: 0 }))
        .then(response => {
          console.log("-------------------HERRE");
          console.log(response.data);
          //self.ready = true;
          if (response.data.success) {
            self.optionsCiudad = [{ label: 'Todos', value: 0 }].concat(response.data.data) //EGM290823
            //self.items = response.data.result;
          } else {
            //self.items = [].concat(self.items, response.data.result);
          }

        })
        .catch(function (error) {
          self.error(error);
        });
    },
    getMediaRegiones(gp) { ///EGM290823
      //sliders de canales
      this.options3 = [];
      var self = this;
      //var arrFavs = [];
      axios
        .post(this.url + "getMediaRegiones", JSON.stringify({ token: self.token, medio: this.medio, grupo: 0 }))
        .then(response => {
          console.log("-------------------HERRE");
          console.log(response.data);
          //self.ready = true;
          if (response.data.success) {
            self.options3 = [{ label: 'Todos', value: 0 }].concat(response.data.data) //EGM290823
            //self.items = response.data.result;
          } else {
            //self.items = [].concat(self.items, response.data.result);
          }

        })
        .catch(function (error) {
          self.error(error);
        });
    },
    search(){
      console.log("search")
      console.log(this.medios[this.medio].fi)
      this.medioAlt = this.medios[this.medio].fi
      this.searchAlt = true;
    },
    cancelarSearch(){
      this.searchAlt = false;
    },
  }
};
</script>

<style scoped>
.button.iconed {
  padding-left: 20px;
}

.chip:hover {
  background: #00b99e;
  fill: #fff;
}

.chip.selectedKeyword:hover {
  background: #ebf9ff;
  fill: #022836;
}

.selectedKeyword {
  background: #00B99E !important;
  fill: #fff;
}

.chip.iconed {
  padding-right: 20px;
}

.icon-card {
  background: none;
}

.vCanales {
  margin: 0 auto;
}

.barTitle {
  color: #fff;
  font-size: 1.6rem;
  font-weight: 500;
  text-align: center;
  margin: 0px;
}

.selectTitle {
  color: #fff;
  font-size: 0.9rem;
  margin: 0px;
}

.toolBarfecha {
  margin-top: 8px;
  color: #fff;
  margin-right: 10px;
  font-size: 1.2rem;
}

.superIndex {
  z-index: 1;
}

.buttonTool {
  color: #1a2a36;
  background: #ebf9ff;
  border-radius: 5px;
  border: none;
  padding: 5px 9px;
  font-size: 16px;
}

.buttonTool:hover {
  color: white;
  fill: white;
  background: #00b99e;
  border-radius: 5px;
  border: none;
  padding: 5px 9px;
  font-size: 16px;
}

.button.tooltip:after {
  z-index: 9999999999;
}



@media screen and (max-width: 991px) {
  .barTitle {
    display: none;
  }

  .toolBarfecha {
    display: none;
  }
}

.escaletaMode {
  background: #00B99E;
  color: white;
}
</style>